// Gösterge etiketleri — çok dillilik (TODO-KPI-09). `api/kpi.ts`'e dokunulmadı (w3-catalog düzenliyor);
// bu dosya yalnız üç etiket ucunu taşır: GET/PUT /kpi/metrics/:id/labels, DELETE .../labels/:lang.

import type { KpiLang, KpiMetricLabel, KpiMetricLabelUpsert } from "@mahir/shared";
import { api } from "./client";

export async function listKpiMetricLabels(metricId: string): Promise<KpiMetricLabel[]> {
  const res = await api<{ labels: KpiMetricLabel[] }>(`/kpi/metrics/${metricId}/labels`);
  return res.labels;
}

export async function upsertKpiMetricLabel(
  metricId: string,
  body: KpiMetricLabelUpsert,
): Promise<KpiMetricLabel> {
  const res = await api<{ label: KpiMetricLabel }>(`/kpi/metrics/${metricId}/labels`, {
    method: "PUT",
    body,
  });
  return res.label;
}

export async function deleteKpiMetricLabel(metricId: string, lang: KpiLang): Promise<void> {
  await api<void>(`/kpi/metrics/${metricId}/labels/${lang}`, { method: "DELETE" });
}
